<template>
  <v-dialog v-model="getTimeTestModal" width="376" class="">
    <v-card class="py-11 px-16 rounded elevation-0">
      <p class="mb-10 text-center font-20px dark-color--text">
        {{ $t("Test.timeout") }}
      </p>
      <div>
        <v-btn
          width="100%"
          height="44px"
          elevation="0"
          hide-selected="true"
          class="button mt-2"
          color="main_color white--text"
          @click="getTimeTestModal = false"
        >
          {{ $t("Default.well") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed, ref, watch } from "@vue/composition-api";
import {
  MutationTypes,
  GettersTypes,
  DispatchTypes,
} from "@/store/modules/tests/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import {} from "@/pages/client/Departments";

export default {
  setup(props, { root }) {
    const store = useStore();
    const { userInfo } = globalVariables();

    const getTimeTestModal = shortComputed(
      {
        storeType: "tests",
        key: "getTimeTestModal",
      },
      MutationTypes.setTimeTestModal
    );

    return {
      store,
      userInfo,
      getTimeTestModal,
    };
  },
};
</script>
